import React, { useEffect, useState } from "react";
import { BiLock } from "react-icons/bi";
import { BsSpeedometer } from "react-icons/bs";
import { errorToast, successToast } from "../../Common/showtoast";
import ApiRequest from "../../Common/restservice";
import { useNavigate } from "react-router-dom";

function Settings({ stateObj: profile, GetMyProfile }) {
  const [currentTab, setCurrentTab] = useState(1);
  const [stateObj, setStateObj] = useState({});
  const [newsLetter, setnewsletter] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setnewsletter(profile.newslettersub === "True");
  }, [profile]);

  const Subscribe = async (_sub) => {
    let res = await ApiRequest(
      "newslettersub.asp",
      "POST",
      JSON.stringify({ subscription: _sub ? "1" : "0" }),
      { Authorization: localStorage.getItem("token") }
    );
    if (res.status === "error") {
      errorToast(res.message);
      return;
    }
    successToast(res.message);
    GetMyProfile();
  };

  const OnChangePassword = async (e) => {
    e.preventDefault();
    if (!stateObj.currentpassword) {
      errorToast("Enter valid current password");
      return;
    } else if (!stateObj.password) {
      errorToast("Enter valid new password");
      return;
    } else if (!stateObj.confirmpassword) {
      errorToast("Enter valid confirm password");
      return;
    } else if (stateObj.password !== stateObj.confirmpassword) {
      errorToast("Password mismatch");
      return;
    }

    let jsoninput = {
      oldpassword: stateObj.currentpassword,
      newpassword: stateObj.password,
    };

    let res = await ApiRequest(
      "ChangePassword.asp",
      "POST",
      JSON.stringify(jsoninput),
      { Authorization: localStorage.getItem("token") }
    );

    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      return;
    }

    successToast(res.message);
    setShowPasswordModal(true); // Show modal instead of redirecting immediately
  };

  return (
    <>
      <div className="card mb-0">
        <div className="card-header">
          <h3 className="card-title">Settings</h3>
        </div>
        <div className="card-body">
          <div className="settings-tab">
            <ul className="tabs-menu nav">
              <li>
                <label
                  onClick={() => setCurrentTab(1)}
                  className={currentTab === 1 ? "active" : ""}
                >
                  <BiLock /> Change Password
                </label>
              </li>
              <li>
                <label
                  onClick={() => setCurrentTab(2)}
                  className={currentTab === 2 ? "active" : ""}
                >
                  <BsSpeedometer /> General
                </label>
              </li>
            </ul>
            <div className="tab-content">
              <div
                className={`tab-pane ${currentTab === 1 ? "active show" : ""}`}
                id="tab1"
              >
                <form className="form-horizontal" onSubmit={OnChangePassword}>
                  <div className="form-group">
                    <div className="row">
                      <div className="col-md-3">
                        <label className="form-label">Current Password</label>
                      </div>
                      <div className="col-md-9">
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Your Current Password"
                          onChange={(e) =>
                            setStateObj({
                              ...stateObj,
                              currentpassword: e.target.value,
                            })
                          }
                          value={stateObj.currentpassword || ""}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="row">
                      <div className="col-md-3">
                        <label className="form-label">New Password</label>
                      </div>
                      <div className="col-md-9">
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Your New Password"
                          onChange={(e) =>
                            setStateObj({
                              ...stateObj,
                              password: e.target.value,
                            })
                          }
                          value={stateObj.password || ""}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="row">
                      <div className="col-md-3">
                        <label className="form-label">Confirm Password</label>
                      </div>
                      <div className="col-md-9">
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Re-enter Your New Password"
                          onChange={(e) =>
                            setStateObj({
                              ...stateObj,
                              confirmpassword: e.target.value,
                            })
                          }
                          value={stateObj.confirmpassword || ""}
                        />
                      </div>
                    </div>
                  </div>

                  <button type="submit" className="btn btn-primary">
                    Submit
                  </button>
                </form>
              </div>

              <div
                className={`tab-pane ${currentTab === 2 ? "active show" : ""}`}
                id="tab2"
              >
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-3">
                      <label className="form-label">Newsletter:</label>
                    </div>
                    <div className="col-md-9">
                      <label className="form-switch">
                        <input
                          type="checkbox"
                          name="form-switch-checkbox"
                          className="form-switch-input"
                          onChange={() => Subscribe(!newsLetter)}
                          checked={newsLetter}
                        />
                        <span className="form-switch-indicator"></span>
                        <span className="form-switch-description">On/Off</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Inline-styled Modal */}
      {showPasswordModal && (
        <>
          {/* Backdrop */}
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              height: "100vh",
              width: "100vw",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 999,
            }}
          ></div>

          {/* Modal */}
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "white",
              padding: "24px",
              borderRadius: "8px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
              zIndex: 1000,
              maxWidth: "400px",
              width: "90%",
              textAlign: "center",
            }}
          >
            <h4 style={{ marginBottom: "16px" }}>Password Changed</h4>
            <p style={{ marginBottom: "24px" }}>
              Your password has been successfully changed.<br />
              Please login again with your new password.
            </p>
            <button
              className="btn btn-primary"
              onClick={() => {
                setShowPasswordModal(false);
                localStorage.clear();
                navigate("/login");
              }}
            >
              OK
            </button>
          </div>
        </>
      )}
    </>
  );
}

export default Settings;
